import useDialog from "../../utils/useDialog";
import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";

const ModalPortal = ({ children, viewClass, onClose, label }) => {
  const dialogRef = useRef(null);
  useDialog(dialogRef, onClose);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setOpen(true), 10);
    return () => clearTimeout(timer);
  }, []);

  return createPortal(
    <div className={`modal-root ${open ? "modal-open" : null}`}>
      <div ref={dialogRef} role="dialog" aria-modal="true" aria-label={label} tabIndex={-1} className={`tt-modal ${viewClass}`}>{children}</div>
    </div>,
    document.getElementById("modal_root")
  );
};

export default ModalPortal;
